module.exports = __webpack_public_path__ + "img/activity_img.36372057.png";